export function getDataTestId() {
    let elements = [];
    for (let i = 0, len = arguments.length; i < len; i++) {
        if (arguments[i] || arguments[i] === 0) {
            elements.push(arguments[i].toString().replaceAll(" ", "-").replace(/[^\w.-]/g, "").toLowerCase())
        }
    }
    return elements.join(".");
}